import { MaskedLine, Micro, Reveal, SlideBody, SlideShell } from "../shared";

const Card = ({ n, kicker, title, text, foot, delay }) => (
  <Reveal delay={delay} className="h-full">
    <div className="group relative flex h-full min-h-[300px] flex-col justify-between overflow-hidden border border-[#D4AF37]/20 bg-[#0E1A36]/50 p-8 transition-colors duration-500 hover:border-[#D4AF37]/50 lg:p-10">
      <span className="pointer-events-none absolute -top-4 right-5 font-serif text-[7rem] leading-none text-[#D4AF37]/10 transition-colors duration-500 group-hover:text-[#D4AF37]/20 lg:text-[9rem]">
        {n}
      </span>
      <div className="relative">
        <Micro>{kicker}</Micro>
        <h3 className="mt-4 max-w-[85%] font-serif text-3xl leading-tight tracking-tight text-[#FAF7F2] lg:text-4xl">
          {title}
        </h3>
        <p className="mt-5 max-w-md text-sm leading-relaxed text-[#94A3B8] sm:text-base">{text}</p>
      </div>
      <span className="relative mt-8 font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]/80">
        {foot}
      </span>
    </div>
  </Reveal>
);

export default function Slide07Vantaggi() {
  return (
    <SlideShell theme="navy" testid="slide-7-vantaggi">
      <SlideBody>
        <Reveal>
          <Micro>06 · Per il proprietario</Micro>
        </Reveal>
        <h2 className="mt-5 font-serif text-4xl leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.1}>
            I DUE <em className="italic text-[#D4AF37]">VANTAGGI.</em>
          </MaskedLine>
        </h2>
        <div className="mt-12 grid gap-4 lg:grid-cols-2">
          <Card
            n="01"
            delay={0.35}
            kicker="Vantaggio 01"
            title="INVESTIMENTO ADV"
            text="La villa entra nella Collection e nel piano di advertising internazionale su target USA: più prenotazioni dirette, valore più alto per ogni soggiorno."
            foot="Prenotazioni dirette · ADR in crescita"
          />
          <Card
            n="02"
            delay={0.5}
            kicker="Vantaggio 02"
            title="GUEST PORTAL GRATUITO"
            text="Il concierge digitale dato in comodato al proprietario: zero costi fissi, e nuovi ricavi generati dai servizi venduti durante il soggiorno."
            foot="Zero costi fissi · Ricavi condivisi"
          />
        </div>
      </SlideBody>
    </SlideShell>
  );
}
